"use client";
import { Fragment, jsx } from "react/jsx-runtime";
import { Checkbox } from "@base-ui/react/checkbox";
import { cn } from "../../../utils/index.js";
import { CdnIcon } from "../../CdnIcon/index.js";
import { checkboxVariants } from "./Checkbox.variants.js";
const Checkbox_Checkbox = (props)=>{
    const { emphasis, checkboxClassName, disabled = false, value, checked = false, indeterminate = false, handleChange, ref, size = '20', required, isCheckboxGroup = false, name, ...restProps } = props;
    const { root, indicator, icon } = checkboxVariants({
        size,
        emphasis,
        isCheckboxGroup
    });
    const onCheckedChange = (_ischecked, eventDetails)=>{
        if ('function' == typeof handleChange) handleChange(value, eventDetails.event);
    };
    const classes = cn(root(), checkboxClassName);
    return /*#__PURE__*/ jsx(Checkbox.Root, {
        indeterminate: indeterminate,
        disabled: disabled,
        checked: checked,
        onCheckedChange: onCheckedChange,
        className: classes,
        inputRef: ref,
        value: value,
        required: required,
        name: name,
        ...restProps,
        children: /*#__PURE__*/ jsx(Checkbox.Indicator, {
            hidden: false,
            keepMounted: true,
            className: indicator(),
            render: renderCheckboxIcon({
                icon,
                size
            })
        })
    });
};
function renderCheckboxIcon({ icon, size }) {
    return (props, state)=>{
        const iconName = getIconName({
            state
        });
        if (iconName) return /*#__PURE__*/ jsx(CdnIcon, {
            ...props,
            "aria-hidden": "true",
            className: icon(),
            size: size,
            iconName: iconName
        });
        return /*#__PURE__*/ jsx(Fragment, {});
    };
}
function getIconName({ state }) {
    if (state.checked) return 'check';
    if (state.indeterminate) return 'check_indeterminate_small';
    return null;
}
export { Checkbox_Checkbox as Checkbox };
